/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */






export const LIST_ASSET_FORM_DATA = [
      {
        label: "Select Storefront",
        name: "selectStorefront",
        type: "async-select",
        fieldProps: {
            isMulti: false,
            initialOptions: [
                
            ]
        }
    },
    {
        label: "Select Category",
        name: "selectCategory",
        type: "select-picker",
        fieldProps: {
            isMulti: false,
            initialOptions: []
        }
    },
    {
        label: "Select Network Type",
        name: "selectNetwork",
        type: "select-picker",
        fieldProps: {
            isMulti: false,
            initialOptions: []
        }
    },
    {
        label: "Select Currency",
        name: "selectCurrency",
        type: "select-picker",
        fieldProps: {
            isMulti: false,
            initialOptions: []
        }
    },
    {
        label: "Enter Price ",
        name: "assetPrice",
        type: "number-input",
        fieldProps: {
        }
    },
 
    {
        label: "Platform Fee ",
        name: "platformFee",
        type: "number-input",
        fieldProps: {
           defaultValue:"",
           disabled:true
        }
    },
    {
        label: "Total Price",
        name: "totalPrice",
        type: "number-input",
        fieldProps: {
            defaultValue:"",
           disabled:true
        }
    },
    
    



 
    ]

    export const LIST_ASSET_FIELDS: any ={

        selectCurrency:{
            validators: {
                notEmpty: {
                    message: "Please Select Currency"
                },
            }
        },
        selectCategory: {
            validators: {
                notEmpty: {
                    message: "Please select the category"
                }
    
            }
        },
 
        selectStorefront: {
            validators: {
                notEmpty: {
                    message: "Please select the storefront to list"
                },
    
            }
        },
        selectNetwork: {
            validators: {
                notEmpty: {
                    message: "Please select the network"
                },
    
            }
        },
        assetPrice: {
            validators: {
                notEmpty: {
                    message: "Please Enter the asset price"
                },
    
            }
        },
  
    }

    export const LIST_ASSET_FIELDS_FIAT: any ={

        selectCategory: {
            validators: {
                notEmpty: {
                    message: "Please select the category"
                }
    
            }
        },
 
        selectStorefront: {
            validators: {
                notEmpty: {
                    message: "Please select the storefront to list"
                },
    
            }
        },
        selectNetwork: {
            validators: {
                notEmpty: {
                    message: "Please select the network"
                },
    
            }
        },
        assetPrice: {
            validators: {
                notEmpty: {
                    message: "Please Enter the asset price FIATT"
                },
    
            }
        },
        selectCurrency:{
            validators: {
                notEmpty: {
                    message: "Please Select Currency"
                },
            }
        },
    }

  






export const SHOWCASE_ASSET_FORM_DATA = [
    {
      label: "Select Storefront",
      name: "selectStorefront",
      type: "select-picker",
      fieldProps: {
          isMulti: false,
          initialOptions: [
              
          ]
      }
  },
  {
      label: "Select Category",
      name: "selectCategory",
      type: "select-picker",
      fieldProps: {
          isMulti: false,
          initialOptions: []
      }
  },
  {
      label: "Select Network Type",
      name: "selectNetwork",
      type: "select-picker",
      fieldProps: {
          isMulti: false,
          initialOptions: [
              {
                  label:"Ethereum",
                  value:"ethereum"
              },
              {
                  label:"Polygon",
                  value:"polygon"
              }
          ]
      }
  },


  // {
  //     label: "Enter Price in USD",
  //     name: "fiat",
  //     type: "currency-input",
  //     fieldProps: {
  //         intlconfig: {
  //             locale: "en-US",
  //             currency: "USD"
  //         },
  //         allowNegativeValue: false,
  //         decimalLimit: 20,
  //         prefix: "$"
  //     }
  // },
  // {
  //     label: "Enter Price in Ether",
  //     name: "crypto",
  //     type: "currency-input",
  //     fieldProps: {
  //         intlconfig: {
  //             locale: "en-US",
  //             currency: "ETH"
  //         },
  //         allowNegativeValue: false,
  //         decimalLimit: 10,
  //         prefix: "Ξ"
  //     }
  // },

  // {
  //     label: "Enter Price in USD ($)",
  //     name: "fiat",
  //     type: "number-input",
  //     fieldProps: {}
  // },
  // {
  //     label: "Enter Price in Crypto (Ξ)",
  //     name: "crypto",
  //     type: "number-input",
  //     fieldProps: {}
  // },




  ]

  export const SHOWCASE_ASSET_FIELDS: any ={

      selectCategory: {
          validators: {
              notEmpty: {
                  message: "Please select the category"
              }
  
          }
      },

      selectStorefront: {
          validators: {
              notEmpty: {
                  message: "Please select the storefront"
              },
  
          }
      },
      selectNetwork: {
          validators: {
              notEmpty: {
                  message: "Please select the network"
              },
  
          }
      }
  }